import  { useEffect } from "react";
import AuthPageLayout from "../../components/authPageLayout/AuthPageLayout";
import useAuthStore from "../../store/authStore";
const Logout = () => {
  const setIsAuthenticated = useAuthStore((s) => s.setIsAuthenticated);
  useEffect(() => {
    setIsAuthenticated(false);
  }, []);
  return (
    <AuthPageLayout>
        
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900 dark:text-gray-100">
          You have successfully logged out!
        </h2>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <p className="mt-10 text-center text-sm text-gray-500">
          <a
            href="/login"
            className="font-semibold leading-6 text-indigo-600 hover:text-indigo-500"
          >
            Sign in again.
          </a>
        </p>

        <p className="mt-10 text-center text-sm text-gray-500">
          Not a member?{" "}
          <a
            href="/register"
            className="font-semibold leading-6 text-indigo-600 hover:text-indigo-500"
          >
            Register
          </a>
        </p>
      </div>
    </AuthPageLayout>
  );
};

export default Logout;
